module.exports = __webpack_public_path__ + "img/aerohive.defd2d54.png";